const privacyStyle = {
    container: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: 1920,
    height: 600,
    backgroundColor: 'transparent',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  showPoweredBy: true
}

export default privacyStyle;